import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import { getReCaptcha } from './endpoints';

const reCaptchaApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReCaptcha: getReCaptcha(builder),
  }),
});

export const { useLazyGetReCaptchaQuery } = reCaptchaApi;
